module.exports = __webpack_public_path__ + "officialStatic/img/cou1.6b2bd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/cou1.png
// module id = d6xq
// module chunks = 0